(function () {
  // gyors helper: termék link keresése a kártyában
  function findProductLink(fromEl) {
    if (!fromEl) return null;
    const card =
      fromEl.closest('.product-item, .product-thumb, .product, .grid__item, li, article, .item') || document;

    // tipikus Shopify termék URL: /products/...
    return card.querySelector('a[href*="/products/"]');
  }

  // 1) Tiltjuk a "quickview" jellegű klikkeket (még mielőtt a theme megkapná)
  document.addEventListener(
    'click',
    function (e) {
      const quick =
        e.target.closest(
          '[data-quickview], [data-quick-view], .quickview, .quick-view, .btn-quickview, .quickview-btn, a[href="#quickview"], a.js-quickview'
        );

      if (quick) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        const link = findProductLink(quick);
        if (link && link.href) {
          window.location.href = link.href;
        }
      }
    },
    true // <-- CAPTURE: ez a lényeg, így a theme előtt elkapjuk
  );

  // 2) Ha a termékkártya "rossz" linket kapott (pl. # vagy javascript:void), javítjuk termék linkre
  document.addEventListener(
    'click',
    function (e) {
      const a = e.target.closest('a');
      if (!a) return;

      // Ha a link nem rendes termék link, de termékkártyán belül van, akkor termék oldalra küldjük
      const href = (a.getAttribute('href') || '').trim();
      const looksBad = !href || href === '#' || href.startsWith('javascript:') || href.includes('#quickview');


    },
    true
  );
})();